import { useContext, useEffect, useState } from "react";
import PropTypes from 'prop-types';
import ApplicationContext from "../../../ApplicationContext";
import { ReleaseHblInfo } from "../../../fms.data/models/ReleaseHblInfo";
import JobListViewContext from "../../common/JobListViewContext";
import { useTypedFastStorage } from "../../../hooks/useFastStorage";
import useDirtyCheck from "../../../hooks/useDirtyCheck2";
import useGlobalOkDialog from "../../../hooks/useGlobalOkDialog";
import React from "react";
import HblRelease from "./implementation/HblRelease";
import { ApiResult, InsertResultsWithData } from "../../../framework.core/data/ApiResult";
import _ from "lodash";
import { SQLField, SQLInfo, SQLType } from "../../../framework.core/data/SQLInfo";
import SecondaryButton from "../../../ui/SecondaryButton";
import { cbmToCft } from "../../../util";
import { CFSManifestReleaseOption } from "../../../framework.core/edi/CFSManifestReleaseOption";
import { getOriginalValue } from "../../../fms.core/data/TrackingModule";
import { historyUpdate } from "../../../fms.data/modules/FmsModFunc";
import fastStorage from "../../../fastStorage";
import { NavigationType, openNewPage } from "../../../util/navigationHelpers";
import { JobNames } from "../../../framework.core/JobNames";
import { useHistory } from "react-router-dom";
import useReportViewer from "../../../hooks/useReportViewer";
import useSetEditedId from "../../../hooks/useSetEditedId";

function HblReleaseImpl({
    hblId,
    storageKey,
    onClose,
    isView,
    fromCFS
}: {
    hblId: number,
    storageKey: string,
    onClose: (x: ReleaseHblInfo | null) => void,
    isView: boolean,
    fromCFS? : boolean
}) {
    const appContext = useContext(ApplicationContext);
    const userid = appContext.user ? appContext.user.id ?? '' : '';
    const jobListContext = useContext(JobListViewContext);
    const history = useHistory();

    const [showGlobalOkDialog] = useGlobalOkDialog();

    const [//initialized
        , setInitialized] = useState(false);
    const [updateFlag, setUpdateFlag] = useState(false);
    const [relFlag, setRelFlag] = useState(false);
    let cfsOption = new CFSManifestReleaseOption();
    const { viewEmptyReport } = useReportViewer();
    const [blInfo, setBlInfo, removeBlInfo, blInfoRef] = useTypedFastStorage<ReleaseHblInfo>(storageKey, null);
    const { setCleanState, dirtyCleanup } = useDirtyCheck(storageKey);
    let hblNo = '';
    let pimsLinkId = 0;
    let rlsYN = '';

  const setSavedEntityOih = useSetEditedId([JobNames.OIHbl]);

    useEffect(() => {
        initialize();
        return () => {
            removeBlInfo();
            dirtyCleanup();
        }
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    function doClose(notifyResult: boolean = false) {
        onClose(notifyResult ? blInfoRef.current : null);
    }

    function RefreshListView(hblId: number) {
        const editModelKey = 'ifms-list-data-/common/joblistview/hbl/oceanImport';
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
        if (keyMatch) {
          const listData = _.values(fastStorage[keyMatch]);
          listData.filter(x => x.id === hblId)[0].rlsStat = blInfoRef.current?.releaseOrder ? 'Y' : 'N';
          listData.filter(x => x.id === hblId)[0].rlsDate = blInfoRef.current?.rlsDate;
          jobListContext.updateDataRow(listData.filter(x => x.id === hblId)[0]);
        }
    }

    async function initialize() {

        const apiResult3 = await appContext.api.getDataForRelease(hblId);
        if (apiResult3 && apiResult3.success) {
            hblNo = apiResult3.result?.hblNo;
            pimsLinkId = +apiResult3.result?.pimsLinkID;
            rlsYN = apiResult3.result?.rlsStat;
        }

        const apiResult2 = await appContext.api.checkReleaseOrder(hblId);
        let cfsyn = 1;
        if (apiResult2 && apiResult2.success) {
            const opt = apiResult2.result as CFSManifestReleaseOption;
            cfsOption = opt;
            if (cfsOption === null || !cfsOption.requestDept || !cfsOption.email)
                cfsyn = 0;
        }

        const apiResult: ApiResult<ReleaseHblInfo> = await appContext.api.getReleaseHblInfo(hblId, 0);

        if (!apiResult) {
            await showGlobalOkDialog('Cannot load data');
            doClose();
            return;
        }

        const loadedModelObj = new ReleaseHblInfo(apiResult.result);

        // init
        loadedModelObj.cft = cbmToCft(loadedModelObj.cbm, 0);
        loadedModelObj.rlsd = loadedModelObj.rlsDate !== null;
        loadedModelObj.cfsYn = (cfsyn === 1);

        setCleanState(loadedModelObj);
        setBlInfo(new ReleaseHblInfo(_.cloneDeep(loadedModelObj)));

        if (blInfoRef.current !== null) {
            blInfoRef.current.trackable = true;
        }

        setInitialized(true);
    }

    async function save() {
        if (!blInfo || !blInfoRef.current) {
            throw new Error('Invalid operation');
        }

        if (!blInfoRef.current.isDirty) {
            //await showGlobalOkDialog(<p>Nothing to save!!!</p>);
            doClose();
            return;
        }

        const si: SQLInfo[] = [];


        si.push(new SQLInfo({
            tableName: 'T_OIHMAIN',
            type: SQLType.Update,
            fields: [
                new SQLField({ fieldName: "F_EXPRLS", propertyName: "EXPRLS", value: blInfo.expRls }),
                new SQLField({ fieldName: "F_OBLCOL", propertyName: "OBLCOL", value: blInfo.oblCol }),
                new SQLField({ fieldName: "F_OBLDATE", propertyName: "OBLDATE", value: blInfo.oblDate }),
                new SQLField({ fieldName: "F_RLSDATE", propertyName: "RLSDATE", value: blInfo.rlsDate }),
                new SQLField({ fieldName: "F_RELEASEBY", propertyName: "RELEASEBY", value: blInfo.rlsBy }),
            ],
            key: new SQLField({ fieldName: "f_id", propertyName: "id", value: hblId })
        }));


        let oriOblCol = getOriginalValue(blInfoRef.current, "oblCol");
        if (oriOblCol > 0 && blInfo.oblCol === 0) {
            let temp = historyUpdate("T_OIHMAIN", hblId, userid, "Cancel O/BL Receive");
            if (temp) si.push(temp);
        }
        if (oriOblCol === 0 && blInfo.oblCol > 0) {
            let temp = historyUpdate("T_OIHMAIN", hblId, userid, "O/BL Receive");
            if (temp) si.push(temp);
        }

        let oriExpRls = getOriginalValue(blInfoRef.current, "expRls");
        if (!oriExpRls && blInfo.expRls) {
            let temp = historyUpdate("T_OIHMAIN", hblId, userid, "Express Released");
            if (temp) si.push(temp);
        }
        if (oriExpRls && !blInfo.expRls) {
            let temp = historyUpdate("T_OIHMAIN", hblId, userid, "Express Released Cancelled");
            if (temp) si.push(temp);
        }

        let oriRlsd = getOriginalValue(blInfoRef.current, "rlsd");
        if (!oriRlsd && blInfo.rlsd) {
            let temp = historyUpdate("T_OIHMAIN", hblId, userid, "Released");
            if (temp) si.push(temp);
        }
        if (oriRlsd && !blInfo.rlsd) {
            let temp = historyUpdate("T_OIHMAIN", hblId, userid, "Released Cancelled");
            if (temp) si.push(temp);
        }

        const apiResult2 = await appContext.api.checkReleaseOrder(hblId);
        if (apiResult2 && apiResult2.success) {
            const opt = apiResult2.result as CFSManifestReleaseOption;
            cfsOption = opt;
        }

        const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveReleaseHblInfo(si,
            {
                pimsLinkId: pimsLinkId,
                rlsBy: blInfo.rlsBy,
                rlsDate: blInfo.rlsDate
            });

        if (apiResult && apiResult.success) {

            //let subCalled = false;
            let result = "";

            if (blInfo.rlsd) {
                if (blInfo.cfsRelOrder) {
                    const apiResult = await appContext.api.makeCfsRelease( +hblId, cfsOption.contact, cfsOption.requestDept)
                    if (apiResult && apiResult.success) {
                        //FrmPrintPreview.RunEmptyReport(false, opt.Email, "Release", vContents, "T_OIHMAIN", listItem.Id);
                    }
                    //subCalled = true;
                }

                if (blInfo.printRelOrder) {
                    setTimeout(() => {
                        openNewPage(history, `/oceanImport/releaseOrderTurnover?jobname=${JobNames.OIHbl}&id=${hblId}`, NavigationType.newPage);
                    }, 1000);
                }
                result = "yes";         // m_bRlsYN
            }

            if(result === 'yes'){
                // Released now...
                await appContext.api.releaseNow({hblId, hblNo});
                RefreshListView(hblId);
            }
            doClose();

            setSavedEntityOih(hblId.toString(), false);

            if (result === 'yes' && fromCFS) {
                const vContents = await appContext.api.makeCfsRelease({ id: +hblId, contact: cfsOption.contact, requestDept: cfsOption.requestDept })
                viewEmptyReport(false, cfsOption.companyId.toString(), 'Release', vContents?.message ?? '' , 'T_OIHMAIN', +hblId, true);
            }
        } else {
            await showGlobalOkDialog(<div>
                <p>Cannot save</p>
                <p>{apiResult?.message}</p>
            </div>);
        }
    }

    return (
        <div>
            {!!blInfo &&
                <div className='report-popup'>
                    <HblReleaseInitializedImpl
                        blInfo={blInfo}
                        setBlInfo={setBlInfo}
                        isView={false}
                        rlsYN={rlsYN}
                        updateFlag={updateFlag} setUpdateFlag={setUpdateFlag}
                        relFlag={relFlag} setRelFlag={setRelFlag}
                    />

                    <div className='report-footer'>
                        <SecondaryButton
                            name='oih-Milestone-cancel-button'
                            size="regular"
                            style={{ width: '90px' }}
                            onClick={doClose}>
                            Cancel
                        </SecondaryButton>
                        <SecondaryButton
                            name='oih-Milestone-update-button'
                            size="regular"
                            style={{ width: '90px' }}
                            disable={!blInfo.rlsBtnEnable}
                            onClick={save}>
                            {blInfo.rlsBtnText}&nbsp;
                        </SecondaryButton>
                    </div>
                </div>
            }
        </div>
    );
}

function HblReleaseInitializedImpl({
    blInfo, setBlInfo,
    rlsYN,
    isView,
    updateFlag, setUpdateFlag,
    relFlag, setRelFlag,
}: {
    blInfo: ReleaseHblInfo,
    setBlInfo: (x: Partial<ReleaseHblInfo>) => void,
    rlsYN: string,
    isView: boolean,
    updateFlag: boolean,
    setUpdateFlag: (x: Partial<boolean>) => void,
    relFlag: boolean,
    setRelFlag: (x: Partial<boolean>) => void,
}) {

    return (
        <HblRelease blInfo={blInfo} setBlInfo={setBlInfo} rlsYN={rlsYN} isView={isView}
            updateFlag={updateFlag} setUpdateFlag={setUpdateFlag}
            relFlag={relFlag} setRelFlag={setRelFlag}
        />
    );
}

const HblReleasePopup = ({
    hblId,
    storageKey,
    onClose,
    isView,
    fromCFS
}: {
    hblId: number,
    storageKey: string,
    onClose: (x: ReleaseHblInfo | null) => void,
    isView: boolean,
    fromCFS? : boolean,
}) => {
    return (
        <HblReleaseImpl
            hblId={hblId} 
            storageKey={storageKey}
            onClose={onClose}
            isView={isView}
            fromCFS={fromCFS}
            />
    );
};

HblReleasePopup.defaultProps = {
};

HblReleasePopup.propTypes = {
    hblId: PropTypes.number.isRequired,
    storageKey: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    isView: PropTypes.bool.isRequired,
    releaseNow: PropTypes.func,
    fromCFS: PropTypes.bool
};

export default React.memo(HblReleasePopup);
